var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"mt-6 red-button-sm w-full",attrs:{"id":"subscribeBtn","type":"button"},on:{"click":function($event){return _vm.getPaymentData(_vm.planName)}}},[_vm._v("Subscribe")])}
var staticRenderFns = []

export { render, staticRenderFns }